<template>
	<div>
		<v-container>
			<v-row :justify="'end'">
				<v-col md="1" style="padding-right: 200px">
					<v-btn color="primary" @click.prevent="abrirNuevo"
						>Agregar Diagnóstico</v-btn
					>
				</v-col>
			</v-row>
			<v-row :align="'stretch'">
				<v-col
					v-for="(diag, i) in valor.Diagnosticos"
					cols="4"
					:key="i"
				>
					<v-card flat color="#f4f4f4" min-height="100%">
						<v-container>
							<v-row dense>
								<v-col class="v-title">
									{{ diag.Tipo.Descripcion }}
								</v-col>
								<v-col md="1" style="padding-right: 30px">
									<v-icon
										color="red"
										@click="borrarDiagnostico(diag)"
										>close</v-icon
									>
								</v-col>
							</v-row>
							<v-row dense>
								<v-col>
									<b>Problema:</b> {{ diag.Problema }}
								</v-col>
							</v-row>
							<v-row dense>
								<v-col>
									<b>Etiología:</b> {{ diag.Etiologia }}
								</v-col>
							</v-row>
							<v-row dense>
								<v-col>
									<b>Síntomas:</b> {{ diag.Sintomas }}
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<v-dialog v-model="diag_nuevo" width="500px"
			><v-card ma-5 persistent>
				<v-card-title class="text-h5 primary--text">
					Nuevo Diagnóstico
					<v-spacer></v-spacer>
					<v-btn icon @click.prevent="cerrarNueva">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form ref="formNueva">
						<v-layout column>
							<v-select
								:rules="[!!nueva.Tipo || 'Campo Obligatorio']"
								return-object
								item-text="Descripcion"
								v-model="nueva.Tipo"
								label="Tipo"
								:items="catalogos.Tipos"
							></v-select>
							<v-select
								:rules="[
									!!nueva.Problema || 'Campo Obligatorio'
								]"
								v-model="nueva.Problema"
								label="Problema"
								:items="listaProblemas(nueva.Tipo)"
							></v-select>
							<v-text-field
								:rules="[
									!!nueva.Etiologia || 'Campo Obligatorio'
								]"
								v-model="nueva.Etiologia"
								label="Etiología"
							>
							</v-text-field>
							<v-text-field
								:rules="[
									!!nueva.Sintomas || 'Campo Obligatorio'
								]"
								v-model="nueva.Sintomas"
								label="Signos y Síntomas"
							></v-text-field>
							<v-btn @click="crear_nueva" color="primary"
								>Guardar</v-btn
							>
						</v-layout>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-layout row class="mt-3" v-if="!esVisita">
			<v-flex xs6>
				<v-btn color="primary" @click.prevent="anterior">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" @click.prevent="guardar">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos", "esVisita"],
	name: "diagnosticoNutricional",
	data() {
		return {
			valor: {
				Diagnosticos: []
			},
			diag_nuevo: false,
			nueva: {
				problema: "",
				etiologia: "",
				sintomas: ""
			},
			editar_diag: false,
			catalogos: {
				Tipos: [],
				Problemas: {
					Ingestion: [
						"Gasto energético incrementado",
						"Ingestión energética deficiente",
						"Ingestión energética excesiva",
						"Ingestión vía oral deficiente",
						"Aceptación limitada de alimentos",
						"Ingestión excesiva de líquidos",
						"Necesidades incrementadas de nutrimentos",
						"Desnutrición",
						"Ingestión energética-proteica deficiente",
						"Necesidades disminuidas de nutrimentos ",
						"Ingestión excesiva de lípidos",
						"Ingestión deficiente de proteína",
						"Ingestión excesiva de proteína",
						"Ingestión excesiva de hidratos de carbono",
						"Ingestión inconsistente de hidratos de carbono",
						"Ingestión deficiente de fibra",
						"Ingestión deficiente de vitaminas",
						"Ingestión deficiente de minerales",
						"Ingestión excesiva de minerales"
					],
					Clinicos: [
						"Dificultad para deglutir",
						"Dificultad para morder/masticar",
						"Alteración en la función gastrointestinal",
						"Alteración en la utilización de nutrimentos",
						"Valores de laboratorio relacionados con la nutrición alterados",
						"Interacción medicamentos-alimentos",
						"Bajo peso",
						"Pérdida de peso involuntaria",
						"Sobrepeso",
						"Obesidad"
					],
					Conductual: [
						"Conocimiento insuficiente en temas relacionados con alimentos y nutrición",
						"No preparado para cambios en dieta y/o estilo de vida",
						"Déficit en el automonitoreo",
						"Apego limitado a las recomendaciones nutricias",
						"Elecciones no deseables de alimentos",
						"Inactividad física",
						"Incapacidad para el autocuidado",
						"Incapacidad para preparar alimentos/comidas",
						"Dificultad para autoalimentarse",
						"Acceso limitado a alimentos"
					],
					Otro: ["Sin diagnóstico nutricio en este momento"]
				}
			},
			problemas: []
		};
	},
	methods: {
		abrirNuevo() {
			this.nueva = {};
			this.diag_nuevo = true;

			if (this.$refs.formNueva) {
				this.$refs.formNueva.reset();
			}
		},
		cerrarNueva() {
			this.diag_nuevo = false;
		},
		listaProblemas(tipo) {
			if (!tipo) {
				return [];
			}
			switch (tipo.ID) {
				case 1:
					return this.catalogos.Problemas.Ingestion;
				case 2:
					return this.catalogos.Problemas.Clinicos;
				case 3:
					return this.catalogos.Problemas.Conductual;
				case 4:
					return this.catalogos.Problemas.Otro;
				default:
					return [];
			}
		},
		crear_nueva() {
			if (this.$refs.formNueva.validate()) {
				this.valor.Diagnosticos.push(this.nueva);
				this.diag_nuevo = false;
				this.nueva = {};
			}
		},
		siguiente() {
			this.$emit("siguiente");
		},
		anterior() {
			this.$emit("anterior");
		},
		async guardar() {
			const res = await ServicioHistorialClinico.guardarDiagnosticoNutricional(
				this.historiaCliniciaId,
				this.valor
			);
			if (res.data.result === 1) {
				this.siguiente();
			} else {
				this.$root.mensajeError = res.data.message;
			}
		},
		obtenerCatalogos() {
			this.catalogos.Tipos = this.$root.generarCatalogo([
				"Ingestión",
				"Clínicos",
				"Conductual/Ambiental",
				"Otro"
			]);
		}
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	mounted() {
		this.obtenerCatalogos();
	},
	watch: {
		datos() {
			if (this.datos) {
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		valor: {
			deep: true,
			handler: function() {
				this.$emit("valorCambiado", this.valor);
			}
		}
	}
};
</script>
